var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#F8F9FA",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "Menu-Hamburguer"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    x: -12.24138,
    y: -10,
    fill: "none",
    height: 39.65517,
    width: 49.82759,
    id: "area"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m1.71034,18.75a0.99655,0.99138 0 0 1 -0.99655,-0.99138a0.99655,0.99138 0 0 1 0.99655,-0.99138l22.92069,0a0.99655,0.99138 0 0 1 0.99655,0.99138a0.99655,0.99138 0 0 1 -0.99655,0.99138l-22.92069,0zm0,-7.93103a0.99655,0.99138 0 0 1 -0.99655,-0.99138a0.99655,0.99138 0 0 1 0.99655,-0.99138l22.92069,0a0.99655,0.99138 0 0 1 0.99655,0.99138a0.99655,0.99138 0 0 1 -0.99655,0.99138l-22.92069,0zm0,-7.93103a0.99655,0.99138 0 0 1 -0.99655,-0.99138a0.99655,0.99138 0 0 1 0.99655,-0.99138l22.92069,0a0.99655,0.99138 0 0 1 0.99655,0.99138a0.99655,0.99138 0 0 1 -0.99655,0.99138l-22.92069,0z",
    "data-name": "menu hamburguer",
    id: "menu_hamburguer"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.72e4d9b49204998770ec7ebebf9a6790.svg";
export { ForwardRef as ReactComponent };